import { render, staticRenderFns } from "./google-sign-in-button.vue?vue&type=template&id=4e301aaf&scoped=true"
import script from "./google-sign-in-button.vue?vue&type=script&lang=js"
export * from "./google-sign-in-button.vue?vue&type=script&lang=js"
import style0 from "./google-sign-in-button.vue?vue&type=style&index=0&id=4e301aaf&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e301aaf",
  null
  
)

export default component.exports